import React, {Component} from 'react';

class NoMatch extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="container my-auto align-self-center">
                <div className="py-5"></div>
                <div className="py-5"></div>
                <div className="row my-auto justify-content-center align-items-center">
                    <div className="card my-auto mx-auto">
                        <h5 className="card-header">Oops!</h5>
                        <div className="card-body text-center">
                            <h5 className="text-muted">The page you're looking for cannot be found</h5>
                        </div>
                        <div className="card-footer text-right">
                            <a className="card-link" href="/">Home</a>
                        </div>
                    </div>
                </div>
                <div className="py-5"></div>
                <div className="py-5"></div>
            </div>
        );
    }
}

export default NoMatch;


// WEBPACK FOOTER //
// ./src/component/NoMatch.js